import { render, staticRenderFns } from "./TemplatesModal.vue?vue&type=template&id=8b8264bc&scoped=true"
import script from "./TemplatesModal.vue?vue&type=script&lang=js"
export * from "./TemplatesModal.vue?vue&type=script&lang=js"
import style0 from "./TemplatesModal.vue?vue&type=style&index=0&id=8b8264bc&prod&scoped=true&lang=scss"
import style1 from "./TemplatesModal.vue?vue&type=style&index=1&id=8b8264bc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8b8264bc",
  null
  
)

export default component.exports